import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import "./jobcentral.css"
import PremiumHeader from './PremiumHeader'


const PremiumJobList = () => {
    const data = useStaticQuery(graphql`
    query PremiumJobQuery {
      jobs: allAirtable(
        filter: { 
          table: { eq: "jobList" } 
          data: { Status: { eq: "premium" } }
        }
        sort: { fields: data___Created, order: DESC }
      ) {
        nodes {
          data {
            applyLink
            company
            roleTitle
            shortDescription
            salary
            location
            glassdoorRating
            Created
            Last_Modified
          }
          recordId
        }
      }
    }
  `);

  
  return (
    <div>
      <PremiumHeader />
      <ul>
        {data.jobs.nodes.map((item, i) => (
          <li class="premiumClass" key={item.recordId}>
            <p>
              {item.data.roleTitle} @ <strong>{item.data.company}</strong> ({item.data.glassdoorRating}/5) | Location: {item.data.location} | Salary: {item.data.salary}
            </p>
            <p>
              <strong>Why it's a good role:</strong> {item.data.shortDescription}
            </p>
            <p>
              Like it? <Link to={item.data.applyLink}>Apply here</Link>
            </p>
            <p class="dateline">Added on {item.data.Created} - last updated {item.data.Last_Modified}</p>
          </li>
        ))}
        {/* ends here */}
        {/* <div
            dangerouslySetInnerHTML={{
           __html: unified()
          .use(markdown)
          .use(html)
          .processSync(item.data.description)
            }}
            /> */}
      </ul>
    </div>
  );  
};

export default PremiumJobList;